'use es6';

export { default as ICON_UNKNOWN_INBOX } from 'bender-url!InboxConnectUtils/images/unknown-email.svg';

/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking
if (!!module && !!module.exports) {
  module.exports.default = module.exports;
}